import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import '@/App.css';
import Home from '@/pages/Home';
import Login from '@/pages/Login';
import AuthCallback from '@/pages/AuthCallback';
import Dashboard from '@/pages/Dashboard';
import Invoices from '@/pages/Invoices';
import Tickets from '@/pages/Tickets';
import Services from '@/pages/Services';
import Pricing from '@/pages/Pricing';
import Subscriptions from '@/pages/Subscriptions';
import Credentials from '@/pages/Credentials';
import AdminDashboard from '@/pages/AdminDashboard';
import TechDashboard from '@/pages/TechDashboard';
import PublicQuote from '@/pages/PublicQuote';
import PublicTicket from '@/pages/PublicTicket';
import SystemStatus from '@/pages/SystemStatus';
import Book from '@/pages/Book';
import NPSSurvey from '@/pages/NPSSurvey';
import InstallPWABanner from '@/components/InstallPWABanner';
import { Toaster } from '@/components/ui/sonner';

function AppRouter() {
  const location = useLocation();
  
  // CRITICAL: Check for session_id in URL hash synchronously (not in useEffect)
  // This prevents race conditions by processing session_id BEFORE checking existing session_token
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  
  return (
    <>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/invoices" element={<Invoices />} />
        <Route path="/tickets" element={<Tickets />} />
        <Route path="/services" element={<Services />} />
        <Route path="/pricing" element={<Pricing />} />
        <Route path="/subscriptions" element={<Subscriptions />} />
        <Route path="/credentials" element={<Credentials />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/tech" element={<TechDashboard />} />
        <Route path="/quote/:token" element={<PublicQuote />} />
        <Route path="/ticket/:token" element={<PublicTicket />} />
        <Route path="/system-status" element={<SystemStatus />} />
        <Route path="/book" element={<Book />} />
        <Route path="/nps/:token" element={<NPSSurvey />} />
      </Routes>
      <Toaster position="top-right" />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
        <InstallPWABanner />
      </BrowserRouter>
    </div>
  );
}

export default App;
